import { render } from "./FpuiInputJson.vue?vue&type=template&id=a89ad55c&lang=pug"
import script from "./FpuiInputJson.vue?vue&type=script&lang=js"
export * from "./FpuiInputJson.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__